//#region src/components/Layout/Layout.module.css
var e = "_horizontalPadding_ayt6h_1", t = "_gridCards_ayt6h_20", n = {
	horizontalPadding: e,
	gridCards: t
};
//#endregion
export { n as default, t as gridCards, e as horizontalPadding };
